<template>
	<div>
		<div>
			<div style="background-color: #ff6976; color: white; padding: 8px" >
				<b>
					Dotychczasowa wersja:
				</b>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "oldVersionMarker"
	};
</script>

<style scoped>

</style>